export default __webpack_public_path__ + "static/media/suitenupcias_10.981ecc28.jpg";